<script setup lang="ts">
const telegramChannelUrl = 'https://t.me/belong_support'
</script>

<template>
  <NuxtLink
    :to="telegramChannelUrl"
    target="_blank"
    class="fixed bottom-5 right-5 rounded-full flex items-center justify-center z-999999"
    aria-label="Telegram Help Button"
  >
    <Icon name="logos:telegram" class="text-4xl" />
  </NuxtLink>
</template>
